module.exports = __webpack_public_path__ + "b07d1c5736b974587e3bddcaa16d252d.glb";